import absWebService from './absWebService';
import i18next from 'i18next';
import enGB from '@locales/abswebservice/enGB';
import deAT from '@locales/abswebservice/deAT';

i18next.addResourceBundle('enGB', 'abswebservice', enGB);
i18next.addResourceBundle('deAT', 'abswebservice', deAT);

export default absWebService;
